// @ts-expect-error pure js
import useResource from "./use-resource.js";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";

interface PennylaneStatus {
  connected: boolean;
  company_id: number | null;
  company_name: string | null;
  user_id: number | null;
  oauth_connected: boolean;
  oauth_expires_at: string | null;
}

interface ConnectInput {
  email: string;
}

export default function usePennylane(profileBailleurId: number) {
  const url = `/profiles/${profileBailleurId}/pennylane`;
  const axios = useAuthenticatedAxios();
  const {
    resource: pennylane,
    error,
    isLoading,
    create: connect,
    del: disconnect,
    mutate,
  } = useResource(url) as {
    resource: PennylaneStatus | null;
    error: Error | undefined;
    isLoading: boolean;
    create: (data: ConnectInput) => Promise<PennylaneStatus>;
    del: () => Promise<null>;
    mutate: () => Promise<unknown>;
  };

  async function getOauthAuthorizationUrl(): Promise<string> {
    const response = await axios.get(`${url}/oauth/authorize`);
    return response.data.authorization_url;
  }

  async function disconnectOauth() {
    const response = await axios.delete(`${url}/oauth`);
    return response.data;
  }

  return {
    pennylane,
    error,
    isLoading,
    connect,
    disconnect,
    mutate,
    getOauthAuthorizationUrl,
    disconnectOauth,
  };
}
